/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ImageLibraryCreateRequest interface.
 */
export function instanceOfImageLibraryCreateRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function ImageLibraryCreateRequestFromJSON(json) {
    return ImageLibraryCreateRequestFromJSONTyped(json, false);
}
export function ImageLibraryCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !exists(json, 'data') ? undefined : json['data'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}
export function ImageLibraryCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
        'description': value.description,
    };
}
